import type { GenericFilterItem } from './filters.types';

type CountEntry = {
  value: string;
  count: number;
};

export const sortFilterItemsByLabel = (a: GenericFilterItem, b: GenericFilterItem): number => {
  const aLabel = (a.label ?? a.value ?? '').toLowerCase();
  const bLabel = (b.label ?? b.value ?? '').toLowerCase();

  if (aLabel < bLabel) return -1;
  if (aLabel > bLabel) return 1;
  return 0;
};

export const mapRecordCountsToItems = (
  counts: Record<string, number> | undefined,
  getLabel?: (value: string) => string | undefined
): GenericFilterItem[] =>
  Object.entries(counts ?? {}).map(([value, count]) => ({
    value,
    count,
    label: getLabel ? (getLabel(value) ?? value) : value,
  }));

export const mapValueCountsToItems = (
  items: CountEntry[] | undefined,
  options?: {
    getLabel?: (value: string) => string | undefined;
    getCheckedValue?: (value: string) => string | undefined;
  }
): GenericFilterItem[] =>
  (items ?? []).map(({ value, count }) => ({
    value,
    count,
    label: options?.getLabel ? (options.getLabel(value) ?? value) : value,
    checkedValue: options?.getCheckedValue ? (options.getCheckedValue(value) ?? value) : undefined,
  }));
